import { z } from 'zod';
export const MembershipStatus = {
    Active: 'active',
    Invited: 'invited',
    Disabled: 'disabled',
};
export const governmentMembershipCreateSchema = z.object({
    departmentId: z.number('Department ID is required'),
    status: z.enum(MembershipStatus).optional(),
    title: z.string().nullish(),
});
